import { EXPERIMENT_PAGE_FEEDBACK_URL } from '../../../constants';

// Returns link to the experiment page feedback form.
export const useExperimentPageFeedbackUrl = () => {
  const url = EXPERIMENT_PAGE_FEEDBACK_URL;
  return url;
};
